import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
var alignMap = {
  top: 'flex-start',
  stretch: 'stretch'
};
var GridRow = styled.div.withConfig({
  displayName: "GridRow",
  componentId: "sc-wkfcad-0"
})(["display:flex;position:relative;align-items:", ";flex-direction:", ";justify-content:flex-start;margin:0 -12px;", ";"], function (props) {
  return alignMap[props.align] || 'center';
}, function (props) {
  return props.reverse ? 'row-reverse' : 'row';
}, function (props) {
  return maxMediaQueries[props.stack === 'tablet' ? 'tablet' : 'phone'](_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex-direction: column;\n  "])));
});
export default GridRow;